export const OohStatus = {
  FAILED: "Failed",
  PASSED: "Passed",
  EXEMPT: "Exempt",
  COMPLETED: "Completed",
};

const OohStatusMap = new Map();
OohStatusMap.set(0, OohStatus.FAILED);
OohStatusMap.set(1, OohStatus.PASSED);
OohStatusMap.set(2, OohStatus.EXEMPT);
OohStatusMap.set(3, OohStatus.COMPLETED);

const OohStatusIconMap = new Map();
OohStatusIconMap.set(OohStatus.PASSED, "fa-regular fa-circle-check");
OohStatusIconMap.set(OohStatus.FAILED, "fa-regular fa-circle-xmark");
OohStatusIconMap.set(OohStatus.EXEMPT, "fa-regular fa-ban");
OohStatusIconMap.set(OohStatus.COMPLETED, "fa-regular fa-circle-check");

export function getOohStatusValue(oohStatus) {
  return OohStatusMap.get(Number(oohStatus));
}

export function getOohStatusIcon(status) {
  return OohStatusIconMap.get(status);
}

export function getAllOohStatus() {
  return [...OohStatusMap.values()];
}
